import { AudioFileBox, SoundfontFileBox } from "@opendaw/studio-boxes";
import { isDefined, isNull, panic, tryCatch, UUID } from "@opendaw/lib-std";
import { Guard } from "./Guard";
export var AudioFiles;
(function (AudioFiles) {
    AudioFiles.validate = (sample, name = "sample") => {
        if (!isDefined(sample) || typeof sample !== "object") {
            return panic(new TypeError(`${name}: expected a Sample, got ${Guard.describe(sample)}`));
        }
        const { uuid, name: fileName, duration } = sample;
        const parsed = tryCatch(() => UUID.parse(Guard.string(uuid, `${name}.uuid`)));
        if (parsed.status === "failure") {
            return panic(new TypeError(`${name}.uuid: '${uuid}' is not a valid uuid`));
        }
        Guard.string(fileName, `${name}.name`);
        if (!(Guard.number(duration, `${name}.duration`) > 0.0)) {
            return panic(new RangeError(`${name}.duration: must be positive, got ${duration}`));
        }
        return sample;
    };
    AudioFiles.use = (context, sample) => {
        const validated = AudioFiles.validate(sample);
        context.samples.set(validated.uuid, validated);
        const uuid = UUID.parse(validated.uuid);
        return context.boxGraph.findBox(uuid).unwrapOrElse(() => AudioFileBox.create(context.boxGraph, uuid, box => {
            box.fileName.setValue(validated.name);
            box.startInSeconds.setValue(0.0);
            box.endInSeconds.setValue(validated.duration);
        }));
    };
    AudioFiles.toSample = (context, box) => {
        const uuid = UUID.toString(box.address.uuid);
        const known = context.samples.get(uuid);
        if (isDefined(known)) {
            return known;
        }
        const sample = {
            uuid,
            name: box.fileName.getValue(),
            duration: box.endInSeconds.getValue() - box.startInSeconds.getValue(),
            bpm: 0,
            sample_rate: 0
        };
        context.samples.set(uuid, sample);
        return sample;
    };
    AudioFiles.useSoundfont = (boxGraph, file) => {
        const parsed = tryCatch(() => UUID.parse(Guard.string(file?.uuid, "soundfont.uuid")));
        if (parsed.status === "failure") {
            return panic(new TypeError(`soundfont.uuid: '${file.uuid}' is not a valid uuid`));
        }
        const name = Guard.string(file.name, "soundfont.name");
        return boxGraph.findBox(parsed.value)
            .unwrapOrElse(() => SoundfontFileBox.create(boxGraph, parsed.value, box => box.fileName.setValue(name)));
    };
    AudioFiles.toSoundfont = (box) => ({ uuid: UUID.toString(box.address.uuid), name: box.fileName.getValue() });
    // File boxes demand at least one referrer, so an unreferenced one is deleted with the last pointer.
    AudioFiles.assign = (context, pointer, provider) => context.edit(() => {
        const previous = pointer.targetVertex.mapOr(vertex => vertex.box, null);
        const target = provider();
        if (isNull(target)) {
            pointer.defer();
        }
        else {
            pointer.refer(target);
        }
        if (!isNull(previous) && previous !== target && previous.pointerHub.size() === 0) {
            previous.delete();
        }
    });
})(AudioFiles || (AudioFiles = {}));
